import Navbar from "../components/Navbar/Navbar";
import Footer from "../components/Footer/Footer";
import styles from "../style/liveupdate.module.css";

export const LiveUpdate = () => {
  const donationData = [
    {
      locationId: 1,
      location: "Eti Osa",
      pintsCollected: 83,
    },
    {
      locationId: 2,
      location: "Ikeja",
      pintsCollected: 79,
    },
    {
      locationId: 3,
      location: "Ikorodu",
      pintsCollected: 33,
    },
    {
      locationId: 4,
      location: "Lagos Island",
      pintsCollected: 34,
    },
    {
      locationId: 5,
      location: "Surulere",
      pintsCollected: 51,
    },
    {
      locationId: 6,
      location: "Yaba",
      pintsCollected: 209,
    },
  ];

  return (
    <div className="liveUpdate">
      <Navbar isLiveUpdate={true} />
      <div
        className={styles.liveupdateHero}
        style={{
          backgroundImage: `linear-gradient(rgba(255, 255, 255, 0.84), rgba(255, 255, 255, 0.84)), url('/assets/background-Image/dots-background.webp')`,
        }}
      >
        <div className={styles.liveupdateSection}>
          <h3 className={styles.liveupdateHeader}>
            YPTGL 2.O Final Statistics
          </h3>

          {/* <p className={styles.time}>
            Last updated at <span>5:00 pm</span>
          </p> */}

          <div className={styles.totalPintLayout}>
            <p>Total Pints of Blood Donated:</p>
            <div className={styles.totalPintDisplay}>
              <h3>
                {donationData.reduce(
                  (total, location) => total + location.pintsCollected,
                  0
                )}
              </h3>
            </div>
          </div>

          <div className={styles.pintDataLayout}>
            <p>Breakdown per location:</p>
            <table className={styles.pintDataTable}>
              <colgroup>
                <col style={{ width: "35%" }} />
                <col style={{ width: "65%" }} />
              </colgroup>
              <thead>
                <tr>
                  <th>Location</th>
                  <th>Number of Pints Donated</th>
                </tr>
              </thead>
              <tbody>
                {donationData.map((donation) => (
                  <tr key={donation.locationId}>
                    <td>{donation.location}</td>
                    <td>{donation.pintsCollected}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <Footer></Footer>
    </div>
  );
};

export default LiveUpdate;
